import { useLinkTo, useNavigation, useRoute } from '@react-navigation/native';
import { useState } from 'react';
import { Platform, TouchableOpacity, View, useWindowDimensions } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { backendApiSlice } from 'services/backend';
import { logoutAction } from 'store/actions';
import { RootState } from 'store/index';
import { toggleKidProfile } from 'store/slices/profileSlice';
import { isMobile } from 'utils/deviceInfo';

import ModalAgeRating from '../ModalAgeRating';
import BandMoreMenu from './BandMoreMenu.web';
import MenuArea from './MenuArea';
import ModalConfirmExitKids from './ModalConfirmExitKids';

import { Icons } from 'components/Icons';
import StreamConnectButton from 'components/Player/Stream/UI/ConnectButton';

const HeaderMenuRightArea: React.FC = () => {
  const route = useRoute();
  const linkTo = useLinkTo();
  const dispatch = useDispatch();
  const navigation = useNavigation<any>();
  const user = useSelector((state: RootState) => state.auth);
  const { width } = useWindowDimensions();
  const { isKid } = useSelector((state: RootState) => state.profile);

  const [modalAgeRatingVisible, setModalAgeRatingVisible] = useState(false);
  const [modalKidProfileVisible, setModalKidProfileVisible] = useState(false);
  const handleSearchPress = () => (isMobile ? navigation.navigate('Search') : linkTo('/buscar'));

  const handleKidLogout = () => {
    dispatch(toggleKidProfile());
    setModalKidProfileVisible(false);
    dispatch(logoutAction());
    dispatch(backendApiSlice.util.resetApiState());
  };

  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          paddingHorizontal: 5,
          gap: 24,
        }}>
        {route.name !== 'Search' && (
          <View style={{ borderWidth: 1, borderColor: 'transparent' }}>
            <TouchableOpacity
              style={{
                width: 15,
                height: 25,
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onPress={handleSearchPress}>
              <Icons.MagnifyinGlass height="22" width="22" />
            </TouchableOpacity>
          </View>
        )}
        <StreamConnectButton />
        <MenuArea
          userData={user}
          toggleAgeRatingModal={() => setModalAgeRatingVisible(!modalAgeRatingVisible)}
          toggleKidProfileModal={() => setModalKidProfileVisible(!modalKidProfileVisible)}
        />
        {Platform.OS === 'web' && width > 479 && !isKid && <BandMoreMenu />}
      </View>

      <ModalConfirmExitKids
        isOpen={modalKidProfileVisible}
        handleKidLogout={handleKidLogout}
        toggleModal={() => setModalKidProfileVisible(!modalKidProfileVisible)}
      />

      <ModalAgeRating
        isOpen={modalAgeRatingVisible}
        toggleModal={() => setModalAgeRatingVisible(!modalAgeRatingVisible)}
      />
    </>
  );
};

export default HeaderMenuRightArea;
